// extracted by mini-css-extract-plugin
export default {"display-none":"adc__display-none--gpO_8","u-pointer-cursor":"adc__u-pointer-cursor--MZNWj","breadcrumbs":"adc__breadcrumbs--YgpNo"};